import React from 'react';
import { IconProps } from '.';

const SvgColoredLineChart = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#7E96F9'
        fillRule='evenodd'
        d='M5.88 15.011a.372.372 0 0 1 .348.025l3.766 2.357 3.938-2.36a.373.373 0 0 1 .24-.05l8.062 1.061a.372.372 0 0 1-.097.737l-7.934-1.045-4.022 2.411a.372.372 0 0 1-.388-.003L6.002 15.77 2.02 17.548a.372.372 0 1 1-.303-.678l4.161-1.859Z'
        clipRule='evenodd'
      />
      <path
        fill='#5AC27C'
        fillRule='evenodd'
        d='M1.508 6.288a.372.372 0 0 1 .446-.278l4.185.973c.046.01.089.03.128.057l3.751 2.603L14.2 7.03a.372.372 0 0 1 .26-.051l4.003.696 3.654-.695a.372.372 0 0 1 .139.73l-3.72.708a.371.371 0 0 1-.134.001l-3.928-.683-4.269 2.667a.372.372 0 0 1-.408-.01L5.9 7.691l-4.116-.957a.372.372 0 0 1-.277-.446Z'
        clipRule='evenodd'
      />
      <path
        fill='#F4847D'
        fillRule='evenodd'
        d='M1.282 9.954a.62.62 0 0 1 .782-.394l4.139 1.37a.618.618 0 0 1 .16.08L9.7 13.347l4.04-3.045a.62.62 0 0 1 .544-.1l3.824 1.104 3.91-1.105a.62.62 0 0 1 .337 1.192l-4.08 1.153a.619.619 0 0 1-.34-.001l-3.697-1.067-4.152 3.129a.62.62 0 0 1-.728.013l-3.63-2.543-4.052-1.34a.62.62 0 0 1-.393-.783Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgColoredLineChart;
